export const toNumberValue = (fieldValue: unknown): number | null =>
  fieldValue !== '' && fieldValue !== undefined && fieldValue !== null
    ? Number(fieldValue)
    : null;
